import React from 'react'
import PropTypes from 'prop-types'
import { getIn } from 'formik'
import { RadioGroup } from 'bs-unified-ui'

const Radio = ({ form, field, onChange, disabled, ...props }) => (
  <RadioGroup
    inputProps={{
      error: getIn(form.touched, field.name) && getIn(form.errors, field.name),
      helperText:
        getIn(form.touched, field.name) && getIn(form.errors, field.name),
    }}
    {...field}
    onChange={(e) => {
      form.setFieldValue(field.name, e.target.value)
      onChange(e.target.value)
    }}
    disabled={disabled || !!form.values.__readOnly}
    {...props}
  />
)

Radio.defaultProps = {
  onChange: () => {},
  disabled: false,
  options: [],
  label: '',
}

Radio.propTypes = {
  onChange: PropTypes.func,
  form: PropTypes.shape().isRequired,
  field: PropTypes.shape().isRequired,
  options: PropTypes.arrayOf(PropTypes.shape()),
  disabled: PropTypes.bool,
  label: PropTypes.string,
}

export default Radio
